<template>
	<Loading :hideInside="false" :state="loading">
		<div class="auth">
      <template v-if="loading">Выход из системы...</template>
      <template v-else><a href="/">Войти в систему...</a></template>
		</div>
	</Loading>
</template>

<script>
	import store from "../store"

	import Loading from "@/components/Loading";

	export default {
		name:    "logout",
		components: {
			Loading
		},
		data() {
			return {
			  loading: true
      };
		},
		async mounted() {
			try {
				await store.dispatch( "user/logout" );
      }
	    catch ( e ) {
			}

      this.loading = false;
		},
		methods: {
		}
	};
</script>

<style scoped>
	.auth {
		text-align: center;
		color: #43525B;
		padding: 2em;
	}
</style>
